import { TFunction } from 'i18next'

const DEFAULT_ERROR_FIELD_NAMES = ['cardHolderName', 'cardNumber', 'cardCvv', 'cardExpiry'] as const

type DefaultErrorFieldName = (typeof DEFAULT_ERROR_FIELD_NAMES)[number]
type DefaultErrorTranslator = (t: TFunction) => string

const DEFAULT_ERROR_TRANSLATORS: Record<DefaultErrorFieldName | 'unknown', DefaultErrorTranslator> = {
  cardHolderName: (t) => t('paymentMethod:errors.default.cardHolderName'),
  cardNumber: (t) => t('paymentMethod:errors.default.cardNumber'),
  cardCvv: (t) => t('paymentMethod:errors.default.cardCvv'),
  cardExpiry: (t) => t('paymentMethod:errors.default.cardExpiry'),
  unknown: (t) => t('paymentMethod:errors.unknown'),
}

const isDefaultErrorFieldName = (name: string): name is DefaultErrorFieldName => DEFAULT_ERROR_FIELD_NAMES.includes(name as DefaultErrorFieldName)

const selectDefaultErrorTranslator = (name: string): DefaultErrorTranslator => {
  if (isDefaultErrorFieldName(name)) {
    return DEFAULT_ERROR_TRANSLATORS[name]
  }

  return DEFAULT_ERROR_TRANSLATORS.unknown
}

export const defaultError = (t: TFunction, name: string): string => selectDefaultErrorTranslator(name)(t)
